export const en = {
  'enter_editing': 'go editor',
  'exam_list': 'exam list',
  '720_editor': '720 editor',
  'logout': 'logout',
  'add_exam': 'add',
  'import_exam': 'import',
  'welcome': 'welcome',
  'delete': 'delete',
  'modify': 'modify',
  'demo': 'demo',
  'copy': 'copy',
  'confirm': 'confirm',
  'cancel': 'cancel',
  'next': 'next',
  'previous': 'previous',
  'finish': 'finish',
  'default': 'default',
  'account': 'account',
  'password': 'password',
  'exam_name': 'name',
  'exam_quantity': 'quantity',
  'exam': 'exam',
  'exam_type': 'type',
  'option': 'option',
  'answer': 'answer',
  'back': 'back',
  'login': 'login',
  'multiple_selection': 'multiple selection',
  'multiple_choice': 'multiple choice',
  'fillIn_name': 'Please fill in the exam name',
  'fillIn_option': 'Please fill in the option',
  'fillIn_exam': 'Please fill in the question name'
}
